import pako from 'pako';  // For decompression if needed
import { mutate } from 'swr';
// import { useContext } from 'react';
// import SnackbarContext from "../ui/snackbar-context.js";



export const handleDisplayResponseResults = (response, snackbarContext, formatSuccess, formatError) => {

    // const snackbarContext=useContext(SnackbarContext);

    const displayError = (result) => {
      const errorMessage = `${formatError(result)}: ${result.message}`
      snackbarContext.openSnackbarError(errorMessage)
    }

    const displaySuccess = (result) => {
      const successMessage = formatSuccess(result)
      snackbarContext.openSnackbarSuccess(successMessage)
    }

    if (response.summary.failedItems > 0) {
      const failedResults = response.results
        .filter((result) => result.status !== 'success')

    //   console.log(`failedResults: ${JSON.stringify(failedResults)}`)
      failedResults.forEach((result) => displayError(result))
    }

    if (response.summary.successfulItems > 0) {
      const successfulResults = response.results
        .filter((result) => result.status === 'success')

    //   console.log(`successfulResults: ${JSON.stringify(successfulResults)}`)
      successfulResults.forEach((result) => displaySuccess(result))
    }

  }


export function handleApiResponse(key, keyID, response, type) {
    if (response.summary.successfulItems > 0) {
        const successfulItems = response.results
            .filter((result) => result.status === 'success')
            .map((result) => result.item);

        switch (type) {
            case 'create':
            case 'update':
                // Mutate the key cache
                mutate(key, async (currentObjects) => {
                    // console.log(`Current objects in cache: ${JSON.stringify(currentObjects)}`);
                    if (!currentObjects) return successfulItems; // Add new items if cache is empty

                    // Convert currentObjects to an array of objects
                    const currentArray = Object.values(currentObjects);

                    let newArray;
                    if (type === 'create') {
                        newArray = [...currentArray, ...successfulItems]; // Append newly created objects
                    } else {
                        newArray = currentArray.map((object) =>
                            successfulItems.find((item) => item[keyID] === object[keyID]) || object
                        ); // Update existing objects
                    }

                    // Convert the array back to an object
                    return newArray.reduce((acc, obj) => ({
                        ...acc,
                        [obj[keyID]]: obj
                    }), {});
                });

                // Mutate individual key caches
                successfulItems.forEach((item) => {
                    mutate([key, item[keyID]], async () => item, false);
                });
                break;

            case 'delete':
                // Remove deleted items from key cache
                mutate(key, async (currentObjects) => {
                    if (!currentObjects) return null; // Return null if cache is empty

                    // Convert currentObjects to an array of objects
                    const currentArray = Object.values(currentObjects);

                    const newArray = currentArray.filter((object) =>
                        !successfulItems.find((item) => item[keyID] === object[keyID])
                    );

                    // Convert the array back to an object
                    return newArray.reduce((acc, obj) => ({
                        ...acc,
                        [obj[keyID]]: obj
                    }), {});
                });

                // Clear individual key caches for deleted items
                successfulItems.forEach((item) => {
                    mutate([key, item[keyID]], null, false);
                });
                break;

            default:
                throw new Error(`Unknown operation type: ${type}`);
        }
    }

    // Return the response for the caller to handle errors
    return response;
}

function parseJsonWithDates(jsonString) {
    return JSON.parse(jsonString, (key, value) => {
      if (typeof value === 'string') {
        // ISO 8601 full datetime regex (UTC format with milliseconds)
        const iso8601Regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,6})?Z$/;
        if (iso8601Regex.test(value)) {
          const result= new Date(value);
        //   console.log(`Parsed date from ISO 8601: ${result}`);
          return result;
        }

        // alternative regex for ISO 8601 with optional timezone offset
        const reISO = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.{0,1}\d*))(?:Z|(\+|-)([\d|:]*))?$/;
        const match = reISO.exec(value);
        if (match) {
          const year = parseInt(match[1], 10);
          const month = parseInt(match[2], 10) - 1; // Months are zero-based
          const day = parseInt(match[3], 10);
          const hour = parseInt(match[4], 10);
          const minute = parseInt(match[5], 10);
          const second = parseFloat(match[6]);
          const date = new Date(Date.UTC(year, month, day, hour, minute, second));

          // Handle timezone offset if present
          if (match[7] && match[8]) {
            const offsetParts = match[8].split(':');
            const offsetHours = parseInt(offsetParts[0], 10);
            const offsetMinutes = offsetParts.length > 1 ? parseInt(offsetParts[1], 10) : 0;
            const offsetMilliseconds = (offsetHours * 60 + offsetMinutes) * 60 * 1000;
            date.setTime(date.getTime() - (match[7] === '-' ? offsetMilliseconds : -offsetMilliseconds));
          }
            // console.log(`Parsed date from alternative ISO 8601: ${date}`);
          return date;
        }
      }
      return value;
    });
  }

export async function processResponse(response) {
    const { body, headers } = response

    const isCompressed = headers['Content-Encoding'] === 'gzip' || headers['X-Compressed'] === 'true';

    if (!isCompressed) {
        //let json = await body.json();
        const jsonString = await body.text()
        //console.log(`Raw JSON string: ${jsonString}`); // Log the raw JSON string
        const json = parseJsonWithDates(jsonString); // Now parse it safely
        //console.log(`Parsed JSON: ${JSON.stringify(json)}`); // Log the parsed JSON
        return json
    }
    else {
        const base64CompressedData = body;
        const compressedData = atob(base64CompressedData);
        const compressedArray = Uint8Array.from(compressedData, c => c.charCodeAt(0));
        let jsonString = pako.inflate(compressedArray, { to: 'string' });
        const json = parseJsonWithDates(jsonString); // Now parse it safely
        return json
    }
}